import { TableException } from "./TableException";

export class PosPendencyException extends TableException {

    constructor () {
        super("Pendência no PDV");
    }

    get variables () {
        return {}
    }

    get template () {
        return "posPendencyException";
    }
    
}
